import * as React from "react";

import { cn } from "@/lib/utils";

function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        "flex min-h-16 w-full field-sizing-content rounded-md border border-[#d7e1dc] bg-white px-3 py-2 text-base text-slate-950 shadow-none outline-none transition-[border-color,box-shadow,background-color] placeholder:text-slate-500 focus-visible:border-[#3f7d73] focus-visible:ring-[3px] focus-visible:ring-[#3f7d73]/20 aria-invalid:border-[#c85b49] aria-invalid:ring-[#c85b49]/15 disabled:cursor-not-allowed disabled:bg-[#f3f4f2] disabled:text-slate-400 md:text-sm",
        className,
      )}
      {...props}
    />
  );
}

export { Textarea };
